import { Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Rating from './Rating';
//import './Product.css'; // (create this if it doesn't exist)
// src={product.image}

const Product = ({ product }) => {

  return (
    <Card className='my-3 p-3 rounded'>
      <Link to={`${product.linkTo}`}>
        <Card.Img
          
          src={product.image ? product.image : '/uploads/Shifts.jpg'}
          variant='top'
          className='product-image'
        />
      </Link>

      <Card.Body>
        <Link to={`${product.linkTo}`}>
          <Card.Title as='div' className='product-title'>
            <strong>{product.name}</strong>
          </Card.Title>
        </Link>
      </Card.Body>
    </Card>
  );
};



export default Product;